module.exports = __webpack_public_path__ + "static/media/deg-shop.03971411.png";